import { render } from "./DemoTransfers.vue?vue&type=template&id=588d3118&scoped=true"
import script from "./DemoTransfers.vue?vue&type=script&lang=js"
export * from "./DemoTransfers.vue?vue&type=script&lang=js"

import "./DemoTransfers.vue?vue&type=style&index=0&id=588d3118&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588d3118"]])

export default __exports__